import { useCallback, useRef, useState } from 'react';

export type ScrollState = {
  x?: number;
  y?: number;
  maxX?: number;
  maxY?: number;
};

const useScrollArea = (horizontal: boolean = false) => {
  const scrollRef = useRef({});

  const [scrollState, setScrollState] = useState<ScrollState>(() => ({
    [horizontal ? 'x' : 'y']: 0,
  }));

  const scrollToPosition = useCallback(
    (position: number = 0, relative: boolean = false) => {
      const axis = horizontal ? 'x' : 'y';
      const axisMax = horizontal ? 'maxX' : 'maxY';

      setScrollState(({ [axis]: prev = 0, [axisMax]: max = 0, ...state }) => ({
        ...state,
        [axisMax]: max,
        [axis]: Math.max(
          0,
          Math.min(max, relative ? prev + position : position)
        ),
      }));
    },
    [horizontal]
  );

  return {
    scrollRef,
    scrollState,
    setScrollState,
    scrollToPosition,
  };
};

export default useScrollArea;
